import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '../../api/api';

/**
 * Most apps have the concept of a User. This is a simple provider
 * with stubs for login/signup/etc.
 *
 * This User provider makes calls to our API at the `login` and `signup` endpoints.
 *
 * By default, it expects `login` and `signup` to return a JSON object of the shape:
 *
 * ```json
 * {
 *   status: 'success',
 *   user: {
 *     // User fields your app needs, like "id", "name", "email", etc.
 *   }
 * }Ø
 * ```
 *
 * If the `status` field is not `success`, then an error is detected and returned.
 */
@Injectable()
export class UserPresensi {
  _user: any;
  is_login = 0;
  akses:any={};
  data: any = {};
  group:any={};
  player_id:any='';
  onesignal_app_id:any='';
  modul_id='2';
  hak_akses_data:any;

  constructor(public api: Api) { }

  /**
   * Send a POST request to our login endpoint with the data
   * the user entered on the form.
   */
  login(accountInfo: any) {
    accountInfo.modul_id = this.modul_id;
    let seq = this.api.post('index.php/login', accountInfo);
    return seq;
  }

  /**
   * Send a POST request to our signup endpoint with the data
   * the user entered on the form.
   */
  signup(accountInfo: any) {
    
    let seq = this.api.post('signup', accountInfo);

    return seq;
  }

  /**
   * Log the user out, which forgets the session
   */
  logout() {
    this._user = null;
  }

  /**
   * Process a login/signup response to store user data
   */
  _loggedIn(resp) {
    this._user = resp.user;
  }

  setSubscription(params){
      return this.api.post('index.php/login/set_subscription', params); 
  }

  requestEditEmployee(params?:any){
    return this.api.post('index.php/myradiant/Profil/requestEditEmployee', params); 
  }
}



// WEBPACK FOOTER //
// ./src/providers/presensi/user/user.ts